/*
 * Free shipping progress bar (cart drawer + cart page).
 * Listens for the theme's "cart:updated" DOM event (dispatched by the
 * quick-cart module on every add/change) and keeps every
 * [data-shipping-progress] element on the page in sync, without a reload.
 */
(function () {
  var THRESHOLD_CENTS = 8500;

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) {
        return '0';
      }
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = format.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var precision = key.indexOf('no_decimals') !== -1 ? 0 : 2;
    var thousands = ',';
    var decimal = '.';
    if (key.indexOf('comma_separator') !== -1) {
      thousands = '.';
      decimal = ',';
    } else if (key.indexOf('apostrophe_separator') !== -1) {
      thousands = "'";
    } else if (key.indexOf('space_separator') !== -1) {
      thousands = ' ';
    }

    var value = withDelimiters(cents, precision, thousands, decimal);
    return format.replace(placeholderRegex, value);
  }

  function updateBar(root, totalPrice, itemCount) {
    var message = root.querySelector('[data-shipping-progress-message]');
    var fill = root.querySelector('[data-shipping-progress-fill]');
    if (!message || !fill) {
      return;
    }

    if (!itemCount) {
      root.setAttribute('hidden', '');
      return;
    }
    root.removeAttribute('hidden');

    var remaining = THRESHOLD_CENTS - totalPrice;
    var percent = Math.min(100, Math.max(0, (totalPrice / THRESHOLD_CENTS) * 100));
    fill.style.width = percent + '%';

    if (remaining <= 0) {
      root.classList.add('shipping-progress--unlocked');
      message.textContent = 'You’ve unlocked free shipping!';
    } else {
      root.classList.remove('shipping-progress--unlocked');
      message.innerHTML = 'You’re <span class="shipping-progress__amount">' + formatMoney(remaining) + '</span> away from free shipping';
    }
  }

  function updateAll(cart) {
    if (!cart) {
      return;
    }
    var roots = document.querySelectorAll('[data-shipping-progress]');
    for (var i = 0; i < roots.length; i++) {
      updateBar(roots[i], cart.total_price, cart.item_count);
    }
  }

  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) {
      updateAll(event.detail.cart);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(updateAll)
      .catch(function () {});
  });
})();
